export class Core {
    public kubun: string = ""
    public hokensha: string = ""
    public bango: string = ""
    public kigo: string = ""
    public kigen_from: string | null = null
    public kigen_to: string | null = null
}
